module.exports = __webpack_public_path__ + "static/img/img-user2.97add8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_new/img-user2.jpg
// module id = PuSs
// module chunks = 0